@if (showOverlay) {
    <div
        class="my-overlay"
        [ngStyle]="{ 'z-index': this.zIndex }"
        [class.transparent]="transparent"
        [class.black-overlay]="black"
        [class.fixed-overlay]="fixed"
    >
        <div class="flex flex-col items-center justify-center gap-4">
            <mat-spinner [class.hide]="hideSpinner" [diameter]="diameter || null" [strokeWidth]="strokeWidth || null"></mat-spinner>
            <ng-content> </ng-content>
        </div>
    </div>
}
